import {createReducer, on} from '@ngrx/store';
import * as contactsActions from './checkout-actions';
import * as fromContacts from './checkout-state';
import {CheckoutInterface, CheckoutResponse} from '@app/marketplace/checkout/_models/checkout.model';

const initialState: fromContacts.State = {isLoading: false, data: {} as CheckoutResponse};
export const reducer = createReducer(
  initialState,
  on(contactsActions.LoadingCheckout, (state) => {
    return {...state, isLoading: true};
  }),
  on(contactsActions.GetCheckout, (state, {data}) => {
    return {...state, isLoading: false, data};
  }),
  on(contactsActions.UpdatingContactByDefault, (state, {contactId}) => {
    return {...state};
  }),
  on(contactsActions.CancelCheckoutRequest, (state) => {
    return {...state, isLoading: true};
  }),
  on(contactsActions.ErrorCheckoutRequest, (state) => {
    return {...state, isLoading: true};
  }),
  on(contactsActions.CleaningCheckout, (state) => {
    return initialState;
  })
);
